export default __webpack_public_path__ + "static/powerPointVirtualGreenScreenc-3a04417e5ac2d894340606154916867f.jpg";